<template>
	<g :transform="'translate(' + x + ',' + y + ')'">
		<rect class="backRect" :x="x + depthOffset.x - x" :y="y - depthOffset.y - y" :width="width" :height="height" />
		
		<g :transform="'translate(3, -19)'">
			<g v-for="(p, index) in parts" :key="index" :transform="'translate(' + (index * (width/parts - (!isFirst ? -2 : 0)) ) + ', 0)'">
				<path d="M32.5489 0.0281982H32.0344L2.02867 17.9999H2.54316L32.5489 0.0281982Z" fill="#EBECEC"/>
				<path fill-rule="evenodd" clip-rule="evenodd" d="M4.59918 17.9796C3.9176 17.9796 3.23602 17.9796 2.55444 17.9796L32.5439 0C33.2255 0 33.907 0 34.5886 0L4.59918 17.9796Z" fill="#C5C6C6"/>
				<path d="M35.1212 0.0281982H34.6067L4.60094 17.9999H5.11542L35.1212 0.0281982Z" fill="#B2B3B3"/>
				<path d="M77.5201 0.0281982H77.0056L46.9999 17.9999H47.5143L77.5201 0.0281982Z" fill="#EBECEC"/>
				<path fill-rule="evenodd" clip-rule="evenodd" d="M49.5986 17.9796C48.9171 17.9796 48.183 17.9796 47.5015 17.9796L77.5433 0C78.2249 0 78.9065 0 79.5881 0L49.5986 17.9796Z" fill="#C5C6C6"/>
				<path d="M80.0924 0.0281982H79.5779L49.5721 17.9999H50.0866L80.0924 0.0281982Z" fill="#B2B3B3"/>
				<path d="M41.5203 0.0281982H41.0059L11.0001 17.9999H11.5146L41.5203 0.0281982Z" fill="#EBECEC"/>
				<path d="M41.5199 0.0281982H42.0344L12.0287 17.9999H11.5142L41.5199 0.0281982Z" fill="#FEFEFE"/>
				<path d="M42.0348 0.0281982H42.5493L12.5436 17.9999H12.0291L42.0348 0.0281982Z" fill="#C5C6C6"/>
				<path d="M43.0638 0.0281982H42.5493L12.5436 17.9999H13.058L43.0638 0.0281982Z" fill="#D9DADA"/>
				<path d="M50.5203 0.0281982H50.0059L20.0001 17.9999H20.5146L50.5203 0.0281982Z" fill="#EBECEC"/>
				<path d="M50.5204 0.0281982H51.0349L21.0292 17.9999H20.5147L50.5204 0.0281982Z" fill="#FEFEFE"/>
				<path d="M51.0348 0.0281982H51.5493L21.5436 17.9999H21.0291L51.0348 0.0281982Z" fill="#C5C6C6"/>
				<path d="M52.0638 0.0281982H51.5493L21.5436 17.9999H22.058L52.0638 0.0281982Z" fill="#D9DADA"/>
				<path d="M59.5201 0.0281982H59.0056L28.9999 17.9999H29.5143L59.5201 0.0281982Z" fill="#EBECEC"/>
				<path d="M59.5204 0.0281982H60.0349L30.0292 17.9999H29.5147L59.5204 0.0281982Z" fill="#FEFEFE"/>
				<path d="M60.0346 0.0281982H60.5491L30.5433 17.9999H30.0288L60.0346 0.0281982Z" fill="#C5C6C6"/>
				<path d="M61.0636 0.0281982H60.5491L30.5433 17.9999H31.0578L61.0636 0.0281982Z" fill="#D9DADA"/>
				<path d="M68.5201 0.0281982H68.0056L37.9999 17.9999H38.5143L68.5201 0.0281982Z" fill="#EBECEC"/>
				<path d="M68.5204 0.0281982H69.0349L39.0292 17.9999H38.5147L68.5204 0.0281982Z" fill="#FEFEFE"/>
				<path d="M69.0346 0.0281982H69.5491L39.5433 17.9999H39.0288L69.0346 0.0281982Z" fill="#C5C6C6"/>
				<path d="M70.0636 0.0281982H69.5491L39.5433 17.9999H40.0578L70.0636 0.0281982Z" fill="#D9DADA"/>
				<path d="M7.53561 14.2978L8.04761 14L56.0018 14L55.4898 14.2978L7.53561 14.2978Z" fill="#EBECEC"/>
				<path d="M7.02365 14.5954L7.53564 14.2976L55.4916 14.2976L54.9796 14.5954L7.02365 14.5954Z" fill="#FEFEFE"/>
				<path d="M7.02396 14.5954L6.51196 14.8932L54.4694 14.8932L54.9814 14.5954L7.02396 14.5954Z" fill="#C5C6C6"/>
				<path d="M5.99997 15.191L6.51196 14.8932L54.4712 14.8932L53.9592 15.191L5.99997 15.191Z" fill="#D9DADA"/>
				<path d="M12.5356 11.2796L13.0476 10.9757L61.0018 10.9757L60.4898 11.2796L12.5356 11.2796Z" fill="#EBECEC"/>
				<path d="M12.0237 11.5833L12.5356 11.2794L60.4916 11.2794L59.9796 11.5833L12.0237 11.5833Z" fill="#FEFEFE"/>
				<path d="M12.024 11.5832L11.512 11.8871L59.4694 11.8871L59.9814 11.5832L12.024 11.5832Z" fill="#C5C6C6"/>
				<path d="M11 12.191L11.512 11.8871L59.4712 11.8871L58.9592 12.191L11 12.191Z" fill="#D9DADA"/>
				<path d="M17.5356 8.27959L18.0476 7.97571L66.0018 7.97571L65.4898 8.27959L17.5356 8.27959Z" fill="#EBECEC"/>
				<path d="M17.0237 8.5833L17.5356 8.27942L65.4916 8.27942L64.9796 8.5833L17.0237 8.5833Z" fill="#FEFEFE"/>
				<path d="M17.024 8.5832L16.512 8.88708L64.4694 8.88708L64.9814 8.5832L17.024 8.5832Z" fill="#C5C6C6"/>
				<path d="M16 9.19097L16.512 8.88708L64.4712 8.88708L63.9592 9.19097L16 9.19097Z" fill="#D9DADA"/>
				<path d="M22.5356 5.27959L23.0476 4.97571L71.0018 4.97571L70.4898 5.27959L22.5356 5.27959Z" fill="#EBECEC"/>
				<path d="M22.0237 5.5833L22.5356 5.27942L70.4916 5.27942L69.9796 5.5833L22.0237 5.5833Z" fill="#FEFEFE"/>
				<path d="M22.024 5.5832L21.512 5.88708L69.4694 5.88708L69.9814 5.5832L22.024 5.5832Z" fill="#C5C6C6"/>
				<path d="M21 6.19097L21.512 5.88708L69.4712 5.88708L68.9592 6.19097L21 6.19097Z" fill="#D9DADA"/>
				<path d="M27.5356 2.27959L28.0476 1.97571L76.0018 1.97571L75.4898 2.27959L27.5356 2.27959Z" fill="#EBECEC"/>
				<path d="M27.0237 2.5833L27.5356 2.27942L75.4916 2.27942L74.9796 2.5833L27.0237 2.5833Z" fill="#FEFEFE"/>
				<path d="M27.024 2.5832L26.512 2.88708L74.4694 2.88708L74.9814 2.5832L27.024 2.5832Z" fill="#C5C6C6"/>
				<path d="M26 3.19097L26.512 2.88708L74.4712 2.88708L73.9592 3.19097L26 3.19097Z" fill="#D9DADA"/>
				<path d="M79.5203 0H79.0059L49.0001 17.9717H49.5146L79.5203 0Z" fill="#EBECEC"/>
				<path d="M79.5202 0H80.0347L50.0289 17.9717H49.5144L79.5202 0Z" fill="#FEFEFE"/>
				<path d="M80.0343 0H80.5488L50.5431 17.9717H50.0286L80.0343 0Z" fill="#C5C6C6"/>
				<path d="M81.0633 0H80.5488L50.5431 17.9717H51.0576L81.0633 0Z" fill="#D9DADA"/>
				<path d="M30.5203 0.0281982H30.0059L0.000109076 17.9999H0.514592L30.5203 0.0281982Z" fill="#EBECEC"/>
				<path d="M30.5199 0.0281982H31.0344L1.02867 17.9999H0.514191L30.5199 0.0281982Z" fill="#FEFEFE"/>
				<path d="M31.0343 0.0281982H31.5488L1.54308 17.9999H1.02859L31.0343 0.0281982Z" fill="#C5C6C6"/>
				<path d="M32.0633 0.0281982H31.5488L1.54308 17.9999H2.05756L32.0633 0.0281982Z" fill="#D9DADA"/>
			</g>
		</g>

		<polygon class="topEdge" :points="topEdgeBack" />
		<polygon class="topEdge" :points="topEdgeFront" />

		<line class="topLine" v-for="line in topLines" :x1="line.x1" :y1="line.y1" :x2="line.x2" :y2="line.y2" />
		<rect class="deepRect" :x="x - x" :y="y + 2.3 - y" :width="width" :height="6.3" />
		<rect class="frontRect" :x="x - x" :y="y - y" :width="width" :height="height" />

		<rect class="bottomEdge" :x="x - x" :y="y + 2 - y" :width="width" :height="0.3" />
		<rect class="topEdge" :x="x - x" :y="y + 8 - y" :width="width" :height="1" />
	</g>
</template>

<script>
	export default {
		name: 'ShelfGrid600',
		props: {
			x: Number,
			y: Number,
			width: Number,
			height: {
				type: Number,
				default: 11,
			},
			parts: {
				type: Number,
				default: 6,
			},
			rackOffset: Object,
			depthOffset: Object,
			isFirst: Boolean,
		},
		computed: {
			topLines() {
				const lines = [];
				const partWidth = this.width / this.parts;

				for (let i = 1; i < this.parts; i++) {
					lines.push({
						x1: 0 + partWidth * i,
						y1: 0,
						x2: 0 + this.depthOffset.x + partWidth * i,
						y2: 0 - this.depthOffset.y,
					});
				}

				return lines;
			},
			topEdgeBack() {
				return `${0 + this.depthOffset.x},${0 - this.depthOffset.y}
						${0 + this.width + this.depthOffset.x},${0 - this.depthOffset.y}
						${0 + this.width + this.depthOffset.x - this.rackOffset.x / 2},${0 - this.depthOffset.y + this.rackOffset.y / 2}
						${0 + this.depthOffset.x - this.rackOffset.x / 2},${0 - this.depthOffset.y + this.rackOffset.y / 2}`;
			},
			topEdgeFront() {
				return `0,0
						${0 + this.width},0
						${0 + this.width + this.rackOffset.x / 2},${0 - this.rackOffset.y / 2}
						${0 + this.rackOffset.x / 2},${0 - this.rackOffset.y / 2}`;
			},
		},
	};
</script>

<style scoped>
	.topPolygon {
		fill: #DCDDDE;
	}
	.rightPolygon {
		fill: #C4C6C8;
	}
	.frontRect {
		fill:#DCDDDE;
	}
	.backRect {
		fill:#9FA1A4;
	}
	.topEdge {
		fill: #EFEFF0;
	}
	.topLine {
		stroke: #BABCBE;
		stroke-width: 0.4;
	}
	.bottomEdge {
		fill: #AFB1B4;
	}
	.deepRect {
		fill: #D6D6D6;
	}
	.deepPolygon {
		fill: #B8B8B8;
	}
</style>